import { AdminPanelCard } from "../components/AdminPanelCard";

export function AdminFallbackPanel() {
  return (
    <AdminPanelCard
      title="No panel data"
      description="Select an admin panel from the navigation to view corresponding controls and analytics."
    />
  );
}
